import { Box, Typography } from "@mui/material";

const UpcomingBadge = ({ text, ...props }) => {
  return (
    <Box
      as="span"
      sx={{
        display: "flex",
        position: "absolute",
        top: { xs: 6, md: 10 },
        left: { xs: 6, md: 10 },
        background: "rgba(0,0,0,0.40)",
        color: "secondary.main",
        padding: "0rem 0.25rem",
        borderRadius: "4px",
        zIndex: 2,
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 700 }} {...props}>
        {text}
      </Typography>
    </Box>
  );
};

export default UpcomingBadge;
